import React from 'react';

export default function PublishFormItem (props) {
  const { className, title, children } = props;
  return (
    <dl className={`info_editor info_editor_type2 ${className || ''}`}>
      <dt>{title}</dt>
      <dd>
        {children}
      </dd>
    </dl>
  );
}
